module.exports = __webpack_public_path__ + "static/tan_asfl_logo-loop_v02_small-4e63b9b8050971c9a5d4a4bc3d72a79d.mp4";